import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Text, Platform } from 'react-native'
import { useTheme } from '../../theming/ThemeProvider'
import Identity from './../../utils/Identity'
import { getTextCapitalized } from '../../tools/dataParse'
import { usePlatforms } from '../../hooks/usePlatforms'

const Txt = (props) => {
  const {
    text, identity, color, style, selectable,
    numberOfLines, isCapitalize, testID
  } = props
  const { theme } = useTheme()
  const { isTablet } = usePlatforms()
  // const dispatch = useDispatch()

  const textToShow = text || text === 0 ? text : '- -'

  // const copyToClipboard = useCallback(async () => {
  //   await Clipboard.setString(text)
  //   dispatch(SendToast({ message: 'Copied to clipboard' }))
  // }, [text, dispatch])

  return (
    <Text
      testID={testID}
      accessibilityLabel={testID}
      ellipsizeMode='tail'
      style={[
        Identity.Font(isTablet)[identity],
        {
          color: theme[color || 'BUNKER'],
          flexShrink: 1
        },
        style
      ]}
      numberOfLines={numberOfLines}
      selectable={selectable && Platform.OS !== 'ios'}
    >
      {
        isCapitalize ? getTextCapitalized(textToShow).trim() : textToShow
      }
    </Text>
  )

  // return selectable && Platform.OS === 'ios' ? (
  //   <TouchableOpacity activeOpacity={0.8} onPress={copyToClipboard}>
  //     {TextComponent}
  //   </TouchableOpacity>
  // ) : (
  //   TextComponent
  // )
}

Txt.propTypes = {
  text: PropTypes.any, // text of the component.
  isCapitalize: PropTypes.bool, // if you wish capitalize the text.
  identity: PropTypes.string, // style of text
  color: PropTypes.string, // color of text
  style: Text.propTypes.style, // style to override actual style
  numberOfLines: PropTypes.number,
  selectable: PropTypes.bool,
  testID: PropTypes.string
}

Txt.defaultProps = {
  text: '- -',
  isCapitalize: false,
  avoid: false,
  identity: 'body1',
  color: 'AZTEC',
  onPress: () => {},
  numberOfLines: null,
  selectable: Platform.OS === 'web'
}

export default memo(Txt)
